import { mainTheme } from "themes/themes";

import Classic from "../assets/images/badges/classic.png";
import High from "../assets/images/badges/high.png";
import Low from "../assets/images/badges/low.png";
import Medium from "../assets/images/badges/medium.png";
import NotForMe from "../assets/images/badges/notforme.png";
import Ultra from "../assets/images/badges/ultra.png";

const levels = [
  {
    title: "classic",
    min: 9.0,
    max: 10,
    color: mainTheme.palette.blackPrimary.main,
    imagePath: Classic,
  },
  {
    title: "ultra",
    min: 8.0,
    max: 8.9,
    color: mainTheme.palette.darkPurplePrimary.main,
    imagePath: Ultra,
  },
  {
    title: "high",
    min: 7.0,
    max: 7.9,
    color: mainTheme.palette.darkBluePrimary.main,
    imagePath: High,
  },
  {
    title: "medium",
    min: 6.0,
    max: 6.9,
    color: mainTheme.palette.greenPrimary.main,
    imagePath: Medium,
  },
  {
    title: "low",
    min: 5.0,
    max: 5.9,
    color: mainTheme.palette.orangePrimary.main,
    imagePath: Low,
  },
  {
    title: "notforme",
    min: 0,
    max: 4.9,
    color: mainTheme.palette.redPrimary.main,
    imagePath: NotForMe,
  },
];

// Change to default export
const handleConnectionLevel = (score) => {
  const matchedLevel = levels.find(
    (lvl) => score <= lvl.max && score >= lvl.min
  );

  if (matchedLevel) {
    return {
      title: matchedLevel.title,
      color: matchedLevel.color,
      imagePath: matchedLevel.imagePath,
    };
  }

  throw new Error("Invalid Score!");
};

export default handleConnectionLevel;
